export default "__VITE_ASSET__XbnGeD4s__"